"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardiansService = void 0;
var GuardiansRegistration_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/GuardiansRegistration.json"));
var ipHexConversionUtils_1 = require("../../utils/ipHexConversionUtils");
var mainnetAddresses_1 = require("../mainnetAddresses");
var MAIN_NET_GUARDIANS_REGISTRATION_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.guardiansContract;
var GuardiansService = /** @class */ (function () {
    function GuardiansService(web3, guardiansRegistrationAddress) {
        if (guardiansRegistrationAddress === void 0) { guardiansRegistrationAddress = MAIN_NET_GUARDIANS_REGISTRATION_ADDRESS; }
        this.web3 = web3;
        this.guardiansRegistrationContract = new this.web3.eth.Contract(GuardiansRegistration_json_1.default.abi, guardiansRegistrationAddress);
    }
    GuardiansService.prototype.setFromAccount = function (address) {
        this.guardiansRegistrationContract.options.from = address;
    };
    GuardiansService.prototype.isRegisteredGuardian = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.guardiansRegistrationContract.methods
                        .isRegistered(address)
                        .call()];
            });
        });
    };
    GuardiansService.prototype.readGuardianInfo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var rawResponse, registrationTime, orbsAddr, name, lastUpdateTime, ip, website, guardianInfoResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.guardiansRegistrationContract.methods
                            .getGuardianData(address)
                            .call()];
                    case 1:
                        rawResponse = _a.sent();
                        registrationTime = rawResponse.registrationTime, orbsAddr = rawResponse.orbsAddr, name = rawResponse.name, lastUpdateTime = rawResponse.lastUpdateTime, ip = rawResponse.ip, website = rawResponse.website;
                        guardianInfoResponse = {
                            // contact,
                            ip: ip,
                            lastUpdateTime: parseInt(lastUpdateTime),
                            name: name,
                            orbsAddr: orbsAddr,
                            registrationTime: parseInt(registrationTime),
                            website: website,
                        };
                        return [2 /*return*/, guardianInfoResponse];
                }
            });
        });
    };
    GuardiansService.prototype.readMetaDataKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var detailsPageUrlMetaDataKey, guardiansRegistrationContractMetadataKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.guardiansRegistrationContract.methods.ID_FORM_URL_METADATA_KEY().call()];
                    case 1:
                        detailsPageUrlMetaDataKey = _a.sent();
                        guardiansRegistrationContractMetadataKeys = {
                            detailsPageUrl: detailsPageUrlMetaDataKey,
                        };
                        return [2 /*return*/, guardiansRegistrationContractMetadataKeys];
                }
            });
        });
    };
    GuardiansService.prototype.readGuardianDetailsPageUrl = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var metadataKeys, guardianDetailsPageUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readMetaDataKeys()];
                    case 1:
                        metadataKeys = _a.sent();
                        return [4 /*yield*/, this.guardiansRegistrationContract.methods
                                .getMetadata(address, metadataKeys.detailsPageUrl)
                                .call()];
                    case 2:
                        guardianDetailsPageUrl = _a.sent();
                        if (!guardianDetailsPageUrl || !guardianDetailsPageUrl.length) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, guardianDetailsPageUrl];
                }
            });
        });
    };
    GuardiansService.prototype.setGuardianDetailsPageUrl = function (detailsPageUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var metadataKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readMetaDataKeys()];
                    case 1:
                        metadataKeys = _a.sent();
                        return [2 /*return*/, this.guardiansRegistrationContract.methods
                                .setMetadata(metadataKeys.detailsPageUrl, detailsPageUrl)
                                .send()];
                }
            });
        });
    };
    GuardiansService.prototype.registerGuardian = function (guardianRegistrationPayload) {
        var website = guardianRegistrationPayload.website, name = guardianRegistrationPayload.name, orbsAddr = guardianRegistrationPayload.orbsAddr, ip = guardianRegistrationPayload.ip;
        var ipAsHex = ipHexConversionUtils_1.ipv4ToHex(ip);
        return this.guardiansRegistrationContract.methods
            .registerGuardian(ipAsHex, orbsAddr, name, website)
            .send();
    };
    GuardiansService.prototype.updateGuardianInfo = function (guardianUpdatePayload) {
        var ip = guardianUpdatePayload.ip, name = guardianUpdatePayload.name, orbsAddr = guardianUpdatePayload.orbsAddr, website = guardianUpdatePayload.website;
        var ipAsHex = ipHexConversionUtils_1.ipv4ToHex(ip);
        return this.guardiansRegistrationContract.methods
            .updateGuardian(ipAsHex, orbsAddr, name, website)
            .send();
    };
    GuardiansService.prototype.unregisterGuardian = function () {
        return this.guardiansRegistrationContract.methods
            .unregisterGuardian()
            .send();
    };
    return GuardiansService;
}());
exports.GuardiansService = GuardiansService;
//# sourceMappingURL=GuardiansService.js.map